import { inject, Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, UrlTree } from '@angular/router';

import { MijnRouteKey, MijnRoutes } from '@ap/mijn-navigatie';

import dynamicTitles from '../../dynamic-titles.json';

@Injectable({ providedIn: 'root' })
export class DynamicProcessGuard {
    private readonly router = inject(Router);

    public canActivate(route: ActivatedRouteSnapshot): boolean | UrlTree {
        const friendlyPath = route.params['webcomponent'] ?? route.parent?.params['webcomponent'];
        if (friendlyPath && friendlyPath in dynamicTitles) {
            return true;
        }
        return this.router.parseUrl(MijnRoutes.get(MijnRouteKey.PAGE_NOT_FOUND).path);
    }
}
